import { render, staticRenderFns } from "./NoProvider.vue?vue&type=template&id=2b994ff0"
import script from "./NoProvider.vue?vue&type=script&lang=js"
export * from "./NoProvider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports